// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeintergrity_main_container{
    height: 626px;
    background-color: #012D01;
    padding: 0 50px;
    position: relative;
    color: #ffffff;
}

.homeintergrity_container{
    display: flex;
    align-items: center;
    gap: 40px;
    padding-top: 100px;
}

.homeintergrity_text1{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    color: #EAAD11;
}

.integritybgImg_comtainer{
    position: absolute;
    bottom: -4px;
    right: 0;
}

.homeintergrity_texth3{
    font-weight: 700;
    font-size: 36px;
    line-height: 55px;
}

.homeintergrity_text2{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    width: 533px;
}


/* responsiveness starts here */

@media screen and (max-width: 1050px){

    .homeintergrity_gallery img{
        width: 500px;
    }

    .integritybgImg_comtainer{
        position: absolute;
        bottom: -4px;
        right: 0;
    }
    
    
    .homeintergrity_text2{
        width: 400px;
    }

    

}


@media screen and (max-width: 900px){

    .homeintergrity_main_container{
        height: 580px;
    }

    .homeintergrity_gallery img{
        width: 350px;
    }

    .integritybgImg_comtainer{
        position: absolute;
        bottom: -4px;
        right: 0;
    }
    
    .integritybgImg_comtainer img{
        width: 100%;
        /* height: 330px; */
    }

    .homeintergrity_text1{
        font-size: 16px;
    }
    
    
    .homeintergrity_texth3{
        font-size: 30px;
    }
    

    .homeintergrity_text2{
        width: 300px;
        font-size: 15px;
    }


}

@media screen and (max-width: 500px){

    .homeintergrity_main_container{
        height: 610px;
        padding: 0 20px;
    }
    
    .homeintergrity_container{
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        gap: 20px;
        padding-top: 50px;
    }

    .homeintergrity_text{
        width: 100%;
    }
    
    .homeintergrity_text1{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        color: #EAAD11;
    }
    
    .integritybgImg_comtainer{
        position: absolute;
        bottom: -3;
        right: 0;
    }
    
    .homeintergrity_texth3{
        font-weight: 700;
        font-size: 24px;
        line-height: 55px;
    }
    
    .homeintergrity_text2{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        width: 100%;
    }

    .homeintergrity_gallery img{
        width: 100%;
    }

    
}


@media screen and (max-width: 380px){

    .homeintergrity_main_container{
        height: 560px;
    }
     
    .homeintergrity_texth3{
        font-size: 20px;
    }
    
    .homeintergrity_text2{
        font-size: 13px;
    }
    
}


@media screen and (max-width: 330px){

    .homeintergrity_main_container{
        height: 560px;
    }
    
     
    .homeintergrity_texth3{
        font-size: 18px;
    }
    
    .homeintergrity_text2{
        font-size: 13px;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/styles/Intergrity.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;;AAGA,+BAA+B;;AAE/B;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,QAAQ;IACZ;;;IAGA;QACI,YAAY;IAChB;;;;AAIJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;;IAGA;QACI,YAAY;QACZ,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;;AAGJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":[".homeintergrity_main_container{\n    height: 626px;\n    background-color: #012D01;\n    padding: 0 50px;\n    position: relative;\n    color: #ffffff;\n}\n\n.homeintergrity_container{\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    padding-top: 100px;\n}\n\n.homeintergrity_text1{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    color: #EAAD11;\n}\n\n.integritybgImg_comtainer{\n    position: absolute;\n    bottom: -4px;\n    right: 0;\n}\n\n.homeintergrity_texth3{\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 55px;\n}\n\n.homeintergrity_text2{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    width: 533px;\n}\n\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n\n    .homeintergrity_gallery img{\n        width: 500px;\n    }\n\n    .integritybgImg_comtainer{\n        position: absolute;\n        bottom: -4px;\n        right: 0;\n    }\n    \n    \n    .homeintergrity_text2{\n        width: 400px;\n    }\n\n    \n\n}\n\n\n@media screen and (max-width: 900px){\n\n    .homeintergrity_main_container{\n        height: 580px;\n    }\n\n    .homeintergrity_gallery img{\n        width: 350px;\n    }\n\n    .integritybgImg_comtainer{\n        position: absolute;\n        bottom: -4px;\n        right: 0;\n    }\n    \n    .integritybgImg_comtainer img{\n        width: 100%;\n        /* height: 330px; */\n    }\n\n    .homeintergrity_text1{\n        font-size: 16px;\n    }\n    \n    \n    .homeintergrity_texth3{\n        font-size: 30px;\n    }\n    \n\n    .homeintergrity_text2{\n        width: 300px;\n        font-size: 15px;\n    }\n\n\n}\n\n@media screen and (max-width: 500px){\n\n    .homeintergrity_main_container{\n        height: 610px;\n        padding: 0 20px;\n    }\n    \n    .homeintergrity_container{\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        padding-top: 50px;\n    }\n\n    .homeintergrity_text{\n        width: 100%;\n    }\n    \n    .homeintergrity_text1{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        color: #EAAD11;\n    }\n    \n    .integritybgImg_comtainer{\n        position: absolute;\n        bottom: -3;\n        right: 0;\n    }\n    \n    .homeintergrity_texth3{\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 55px;\n    }\n    \n    .homeintergrity_text2{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        width: 100%;\n    }\n\n    .homeintergrity_gallery img{\n        width: 100%;\n    }\n\n    \n}\n\n\n@media screen and (max-width: 380px){\n\n    .homeintergrity_main_container{\n        height: 560px;\n    }\n     \n    .homeintergrity_texth3{\n        font-size: 20px;\n    }\n    \n    .homeintergrity_text2{\n        font-size: 13px;\n    }\n    \n}\n\n\n@media screen and (max-width: 330px){\n\n    .homeintergrity_main_container{\n        height: 560px;\n    }\n    \n     \n    .homeintergrity_texth3{\n        font-size: 18px;\n    }\n    \n    .homeintergrity_text2{\n        font-size: 13px;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
